/*
Copyright (C) 2025 COMCAST. All Rights Reserved.
 */

function getPolarisHeaderWithDismiss() {
  return document.querySelector<HTMLElement>(
    "xc-header[show-dismiss][dismiss-handler]",
  );
}

function getSigninForm() {
  return document.querySelector<HTMLFormElement>("main form[name='signin']");
}

function addHiddenCancelButtonToForm(form: HTMLFormElement) {
  const cancelButton = document.createElement("button");
  cancelButton.type = "submit";
  cancelButton.name = "cancel";
  cancelButton.value = "true";
  cancelButton.formNoValidate = true;
  cancelButton.hidden = true;
  form.appendChild(cancelButton);
  return cancelButton;
}

function addDismissHandler(
  polarisHeader: HTMLElement,
  cancelButton: HTMLButtonElement,
) {
  polarisHeader.addEventListener("dismiss-clicked", () => {
    cancelButton.click();
  });
}

export default (): void => {
  const polarisHeader = getPolarisHeaderWithDismiss();
  const signinForm = getSigninForm();
  if (polarisHeader && signinForm) {
    const cancelButton = addHiddenCancelButtonToForm(signinForm);
    addDismissHandler(polarisHeader, cancelButton);
  }
};
